import React, {useEffect, useState, useRef} from 'react';
import axios from "axios";
import "./Styles/ImageItem.css";
import { Clock, Wifi } from "react-feather";
import ReactPlayer from "react-player";
import { AskModal } from './AskModal';
import { Loading } from "./Loading";

//import FrameComponent from './FrameComponent';

export const ContentItem = ({history, passPortal, postBalance, user, test}) => {
    const [loadItem, setLoadItem] = useState(true);
    const [counter, setCounter] = useState(8);
    const [type, setType] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [playVideo, setPlayVideo] = useState(true);
    const [endVideo, setEndVideo] = useState(false);
    const [thumnailAdd, setThumnailAdd] = useState(false);
    let interval = null;
    const {campaign, surveyAnsw, search, ghz_condition, token, ap, survey_ids, 
      threshold, userData, skip_seconds, each_seconds,  portal_label_access, 
      portal_label_return, portal_show_timer, show_popup,  backgroundParam,
      fontColorParam,
      fontParam, 
    } = history.location.campaign ? history.location : history.location.state;
    const [band, setBand] = useState();
    const [showContinueView, setShowContinueView] = useState(false);
    const [flagFirstTime, setFlagFirstTime] = useState(true);
    const videoRef = useRef();
    const [maxLengthVideo, setMaxLengthVideo] = useState(skip_seconds ? skip_seconds : 30);
    const eachShow = (each_seconds ? each_seconds : 30 ) * 1000;
    const [hazClick, setHazClick] = useState(true);
    let timeOut = null;

    useEffect(() => {
        return () => {
            if(interval) {
                clearInterval(interval);
            }
        }
    });

    useEffect(() => {
      let band = history.location.band;
      setBand(band);
    }, []);

    useEffect(() => {
      if(playVideo && !flagFirstTime && !endVideo) {
        showAgainOptions();
      } 
    }, [playVideo, endVideo]);

    const saveDownload = async () => {
      const { campaign, ap, DeviceID } = history.location;
      try {
        if(!test) {
          const fields = {
            AccessPointID: ap.ap_mac,
            LocationID: Number(ap.ap_locationid),
            DeviceID,
            CampaignID: campaign.CampaignID,
            MediaType: type,
            download: Number(campaign.CouponDownloads) + 1
          };
          await axios.post("/impressions", { fields });
        }
      } catch (err) {
        console.log(err);
      }
    }

    const _renderItem = () => {
      let s;
      if(surveyAnsw) {
        initCounter();
          return (
            <a href={`/google-storage/${encodeURIComponent(
              campaign.CampaignCouponURL,
            )}`} download="Cupon" blank="_blank">
              <img
                  onClick={() => saveDownload()}
                  onLoad={e => {
                    setLoadItem(false)
                  }}
                  className={"w-100"}
                  style={{
                    objectFit: "contain",
                    height: "100% !important"

                  }}
                  src={`/google-storage/${encodeURIComponent(
                    campaign.CampaignCouponURL,
                  )}`}
                />
            </a>
        );
      }
      if(campaign.CampaignVideoURL) {
        let url = campaign.CampaignVideoURL;
        url = url.includes("youtu") ? campaign.CampaignVideoURL : `/google-storage/${encodeURIComponent(campaign.CampaignVideoURL)}`;
          return (
            <>
              {
                (hazClick && !loadItem) && <span className="spanTitle">Haz click en el vídeo</span>
              }
              <ReactPlayer
                width="100%"
                height="100%"
                ref={videoRef}
                onEnded={() => _endVideo()}
                style={{
                    objectFit: "contain",
                    height: "100% !important"
                }}
                url={url}
                onReady={(e)=> setLoadItem(false)}
                playing={playVideo}
                playsinline={true}
                light={thumnailAdd}
                onPause={(e)=> {
                  if(counter >= 1) {
                    setHazClick(true)
                  }
                }}
                onPlay={(e)=> setHazClick(false)}
                onError={(e) => setThumnailAdd(true)}
                onProgress={(e) => {
                  const seconds = Math.round(e.playedSeconds);
                  s = maxLengthVideo - seconds;
                  setCounter(s <= 0 ? 0 : s);
                  if( seconds === maxLengthVideo && flagFirstTime && show_popup) {
                    setPlayOptions();
                  } 
                }}
                onDuration={(e) => {
                  setMaxLengthVideo(Math.round(e));
                  /*  if(e > maxLengthVideo) {
                    setShowContinueView(true);
                  } */
                }}
              />
            
            </>
          )
        } else {
          initCounter();
          return (
              <img
              onLoad={e => {
                setLoadItem(false)
              }}
              className={"w-100"}
              style={{
                objectFit: "contain",
                height: "100% !important"
              }}
              src={`/google-storage/${encodeURIComponent(
                campaign.CampaignImageURL,
              )}`}
            />
          );
        }

      if(!ghz_condition) {
        if(campaign.CampaignVideoURL) {
          let url = campaign.CampaignVideoURL;
          url = url.includes("youtu") ? campaign.CampaignVideoURL : `/google-storage/${encodeURIComponent(campaign.CampaignVideoURL)}`;
            return (
              <>
                {
                  (hazClick && !loadItem) && <span className="spanTitle">Haz click en el vídeo</span>
                }
                <ReactPlayer
                  width="100%"
                  height="100%"
                  ref={videoRef}
                  onEnded={() => _endVideo()}
                  style={{
                      objectFit: "contain",
                      height: "100% !important"
                  }}
                  url={url}
                  onReady={(e)=> setLoadItem(false)}
                  playing={playVideo}
                  playsinline={true}
                  light={thumnailAdd}
                  onPause={(e)=> {
                    if(counter >= 1) {
                      setHazClick(true)
                    }
                  }}
                  onPlay={(e)=> setHazClick(false)}
                  onError={(e) => setThumnailAdd(true)}
                  onProgress={(e) => {
                    const seconds = Math.round(e.playedSeconds);
                    s = maxLengthVideo - seconds;
                    setCounter(s <= 0 ? 0 : s);
                    if( seconds === maxLengthVideo && flagFirstTime && show_popup) {
                      setPlayOptions();
                    } 
                  }}
                  onDuration={(e) => {
                    setMaxLengthVideo(Math.round(e));
                    /*  if(e > maxLengthVideo) {
                      setShowContinueView(true);
                    } */
                  }}
                />
              
              </>
            )
          } else {
            initCounter();
            return (
                <img
                onLoad={e => {
                  setLoadItem(false)
                }}
                className={"w-100"}
                style={{
                  objectFit: "contain",
                  height: "100% !important"

                }}
                src={`/google-storage/${encodeURIComponent(
                  campaign.CampaignImageURL,
                )}`}
              />
            );
          }
      }

      if(campaign.ghz5_only && band === 5)  {
        if(campaign.CampaignVideoURL) {
          let url = campaign.CampaignVideoURL;
          url = url.includes("youtu") ? campaign.CampaignVideoURL : `/google-storage/${encodeURIComponent(campaign.CampaignVideoURL)}`;
            return (
              <>
                {
                  (hazClick && !loadItem) && <span className="spanTitle">Haz click en el vídeo</span>
                }
                <ReactPlayer
                  width="100%"
                  height="100%"
                  ref={videoRef}
                  onEnded={() => _endVideo()}
                  style={{
                      objectFit: "contain",
                      height: "100% !important"
                  }}
                  url={url}
                  onReady={(e)=> setLoadItem(false)}
                  playing={playVideo}
                  playsinline={true}
                  light={thumnailAdd}
                  onPause={(e)=> {
                    if(counter >= 1) {
                      setHazClick(true)
                    }
                  }}
                  onPlay={(e)=> setHazClick(false)}
                  onError={(e) => setThumnailAdd(true)}
                  onProgress={(e) => {
                    const seconds = Math.round(e.playedSeconds);
                    s = maxLengthVideo - seconds;
                    setCounter(s <= 0 ? 0 : s);
                    if( seconds === maxLengthVideo && flagFirstTime && show_popup) {
                      setPlayOptions();
                    } 
                  }}
                  onDuration={(e) => {
                    setMaxLengthVideo(Math.round(e));
                    /*  if(e > maxLengthVideo) {
                      setShowContinueView(true);
                    } */
                  }}
                />
              
              </>
            )
          } else {
            initCounter();
            return (
                <img
                onLoad={e => {
                  setLoadItem(false)
                }}
                className={"w-100"}
                style={{
                  objectFit: "contain",
                  height: "100% !important"
                }}
                src={`/google-storage/${encodeURIComponent(
                  campaign.CampaignImageURL,
                )}`}
              />
            );
          }
      } else {
        if(userData && userData.health) {
          if(userData.health >= threshold) {
            if(campaign.CampaignVideoURL) {
              let url = campaign.CampaignVideoURL;
              url = url.includes("youtu") ? campaign.CampaignVideoURL : `/google-storage/${encodeURIComponent(campaign.CampaignVideoURL)}`;
                return (
                  <>
                 {
                  (hazClick && !loadItem) && <span className="spanTitle">Haz click en el video</span>
                }
                  <ReactPlayer
                    width="100%"
                    height="100%"
                    ref={videoRef}
                    onPause={(e)=> {
                      if(counter >= 1) {
                        setHazClick(true)
                      }
                    }}
                    onPlay={(e)=> setHazClick(false)}
                    onEnded={() => _endVideo()}
                    style={{
                        objectFit: "contain",
                        height: "100% !important"

                    }}
                    url={url}
                    playing={playVideo}
                    light={thumnailAdd}
                    onReady={(e)=> setLoadItem(false)}
                    onError={(e) => setThumnailAdd(true)}
                    playsinline={true}
                    onProgress={(e) => {
                      const seconds = Math.round(e.playedSeconds);
                      s = maxLengthVideo - seconds;
                      setCounter(s <= 0 ? 0 : s);
                      if( seconds === maxLengthVideo && flagFirstTime && show_popup) {
                        setPlayOptions();
                      } 
                    }}
                    onDuration={(e) => {
                      setMaxLengthVideo(Math.round(e));
                      /*  if(e > maxLengthVideo) {
                        setShowContinueView(true);
                      } */
                    }}
                  />
                  </>
                )
              } else {
                initCounter();
                return (
                    <img
                    onLoad={e => {
                      setLoadItem(false)
                    }}
                    className={"w-100"}
                    style={{
                      objectFit: "contain",
                      height: "100% !important"

                    }}
                    src={`/google-storage/${encodeURIComponent(
                      campaign.CampaignImageURL,
                    )}`}
                  />
                );
              }
          }
        }
        if(campaign.CampaignImageURL) {
          initCounter();
          return (
              <img
              onLoad={e => {
                setLoadItem(false)
              }}
              className={"w-100"}
              style={{
                objectFit: "contain",
                height: "100% !important"

              }}
              src={`/google-storage/${encodeURIComponent(
                campaign.CampaignImageURL,
              )}`}
            />
          );
        } else {
          let url = campaign.CampaignVideoURL;
          url = url.includes("youtu") ? campaign.CampaignVideoURL : `/google-storage/${encodeURIComponent(campaign.CampaignVideoURL)}`;
          return (
            <>
                {
                  (hazClick && !loadItem) && <span className="spanTitle">Haz click en el vídeo</span>
                }
            <ReactPlayer
              width="100%"
              height="100%"
              ref={videoRef}
              onPause={(e)=> {
                if(counter >= 1) {
                  setHazClick(true)
                }
              }}
              onPlay={(e)=> setHazClick(false)}
              onReady={(e)=> setLoadItem(false)}
              onEnded={() => _endVideo()}
              style={{
                  objectFit: "cover",
                  height: "100% !important"

              }}
              url={url}
              light={thumnailAdd}
              onError={(e) => setThumnailAdd(true)}
              playing={playVideo}
              playsinline={true}
              onProgress={(e) => {
                const seconds = Math.round(e.playedSeconds);
                s = maxLengthVideo - seconds;
                setCounter(s <= 0 ? 0 : s);
                if( seconds === maxLengthVideo && flagFirstTime && show_popup) {
                  setPlayOptions();
                } 
              }}
              onDuration={(e) => {
                setMaxLengthVideo(Math.round(e));
               /*  if(e > maxLengthVideo) {
                  setShowContinueView(true);
                } */
              }}
            />
            </>
          )
        }

      }
      
    }

    const setPlayOptions = () => {
      setShowContinueView(!endVideo);
      setFlagFirstTime(false);
      setPlayVideo(false);
      setType("video");
      if(show_popup) {
        setShowModal(true);
      } else {
        //_postImpression(true);
      }
    }

    const _endVideo = () => {
      setHazClick(false);
      clearTimeout(timeOut);
      setEndVideo(true);
      setShowContinueView(false);
      setType("video");
      if(show_popup) {
        setShowModal(true);
      } else {
        _postImpression(true, "video");
      }
    }
    
    const _postImpression = async (isOk, mediaType) => {
        const { campaign, ap, DeviceID } = history.location;
        try {
          const fields = {
            AccessPointID: ap.ap_mac,
            LocationID: Number(ap.ap_locationid),
            DeviceID,
            CampaignID: campaign.CampaignID,
            MediaType: mediaType ? mediaType : type 
          };
          if(!test) {
            const {data} = await axios.post("/impressions", { fields });
            await postBalance(campaign, mediaType ? mediaType : type, data);
          }
          if(isOk) {
            passPortal(ap, campaign, DeviceID);
         /*    axios.get("/userband", {
              params: {
                DeviceID
              }
            }); */
          }
          
        } catch (err) {
          console.log(err);
        }
    }

    const changePlayVideo = () => {
      console.log("changePlayVideo")
      setPlayVideo(true);
      if(show_popup) {
        setShowModal(true);
      } else {
        _postImpression(true);
      }
      setShowContinueView(false);
      clearInterval(true);
    }

    const _goBack = async () => {

      await _postImpression(false);
      if(search && surveyAnsw) {
        history.history.replace(`/${search}`)
      }else {
        if(search) {
          history.history.replace(`/${search}`)
        } else {
          history.history.goBack();
        }
      }
    }

    const initCounter = () => {
      if(counter === 0 && !show_popup) { 
        clearInterval(interval);
        _postImpression(true, 'image');
        return;
      }
      interval = setInterval(() => {
          if (counter === 0) {
              clearInterval(interval);
              setType("image");
              if(show_popup) {
                setShowModal(true);
              } 
              return;
          }
          setCounter(counter - 1);
      }, 1000);
    }

    const showAgainOptions = () => {
      timeOut = setTimeout(() => {
        setPlayOptions();
      }, eachShow);
    }

    return (
      <>
        <style jsx>{`
          * {
              font-family: ${fontParam};
          }
      `}</style>
        <div className="ImageItemWrapper">
            {showModal && ( (campaign.type_ad === "performance" && !survey_ids.find(id => id === String(campaign.survey_id)) ) ? <AskModal 
                    continueView={showContinueView ? changePlayVideo : null} 
                    portal_label_access={portal_label_access}
                    portal_label_return={portal_label_return}
                    fontParam={fontParam}
                    labelBtn={campaign.labelbtn_action} ok={() => _postImpression(true)} 
                    cancel={_goBack} register={()=> history.history.push("/reqcredit", {
              campaign,
              search,
              user,
              ap,
              DeviceID: history.location.DeviceID
            })}/> : <AskModal fontParam={fontParam}
            portal_label_access={portal_label_access}
            portal_label_return={portal_label_return} continueView={showContinueView ? changePlayVideo : null} ok={() => _postImpression(true)} cancel={_goBack}/>)}
        <div className="ImageItemContainer">
          <div className="ImageItemText">
            <div style={{ display: "contents" }}>
              <Wifi size={32} />
              <span style={{ marginRight: "8px", marginLeft: "8px" }}>
                {" "}
                Internet Gratis:
              </span>
            </div>
            {(portal_show_timer && !loadItem && counter) && <strong style={{fontFamily: fontParam}}>{counter}</strong> }
            
          </div>
          <div className="Content h-100"> 
            <div className={loadItem ? "spinner" : "ImageItem"}>
                  {_renderItem()}
            </div>
   
          </div>
          <div className="ImageItemText align-items-center">
            {/* <Clock size={32} />
            <span style={{ marginRight: "8px", marginLeft: "8px" }}>
              20 min.
            </span> */}
          </div>
          {surveyAnsw && <span className="text-white" style={{ marginRight: "8px", marginLeft: "8px" }}>Haz Click en la imagen para descargar el cupón</span>}
        </div>
        </div>
      </>
    )
}

